// if (!customElements.get('testimonials-component')) {
//   class Testimonials extends HTMLElement {
//     constructor() {
//       super();
//     }

//     connectedCallback() {
//       this.selectors = {
//         sliderWrapper: '.testimonials__items',
//         pagination: '.swiper-pagination',
//         nextEl: '.swiper-btn-next',
//         prevEl: '.swiper-btn-prev',
//       };
//       this.classes = {
//         grid: 'f-grid',
//         swiper: 'swiper',
//         swiperWrapper: 'swiper-wrapper',
//       };

//       this.sectionId = this.dataset.sectionId;
//       this.section = this.closest(`.section-${this.sectionId}`);
//       this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

//       this.enableSlider = this.dataset.enableSlider === 'true';
//       this.items = parseInt(this.dataset.items);
//       this.tabletItems = parseInt(this.dataset.tabletItems);
//       this.tabletLargeItems = parseInt(this.dataset.tabletLargeItems);
//       this.mobileItems = parseFloat(this.dataset.mobileItems) || 1;

//       this.sliderInstance = false;

//       if (!this.enableSlider) return;

//       this.init();
//       document.addEventListener('matchMobile', () => {
//         this.init();
//       });
//       document.addEventListener('unmatchMobile', () => {
//         this.init();
//       });
//     }

//     init() {
//       // Keep slider active on all viewport sizes (mobile included) so swipe/dots work on mobile
//       this.initSlider();
//     }

//     initSlider() {
//       const columnGap = FoxTheme.utils.getGridColumnGap(this.sliderWrapper);

//       const paginationEl = this.section.querySelector(this.selectors.pagination);
//       const sliderOptions = {
//         slidesPerView: parseFloat(this.mobileItems) || 1,
//         spaceBetween: columnGap.mobile,
//         navigation: {
//           nextEl: this.section.querySelector(this.selectors.nextEl),
//           prevEl: this.section.querySelector(this.selectors.prevEl),
//         },
//         pagination: paginationEl ? {
//           el: paginationEl,
//           clickable: true,
//         } : false,
//         breakpoints: {
//           768: {
//             slidesPerView: parseInt(this.tabletItems),
//             spaceBetween: columnGap.tablet
//           },
//           1024: {
//             slidesPerView: parseInt(this.tabletLargeItems),
//             spaceBetween: columnGap.tabletLarge
//           },
//           1280: {
//             slidesPerView: parseInt(this.items),
//             spaceBetween: columnGap.desktop
//           },
//         },
//         loop: true,
//         threshold: 2,
//       };

//       if (typeof this.sliderInstance !== 'object') {
//         this.classList.add(this.classes.swiper);
//         this.sliderWrapper.classList.remove(this.classes.grid);
//         this.sliderWrapper.classList.add(this.classes.swiperWrapper);
//         this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
//         this.sliderInstance.init();

//         const focusableElements = FoxTheme.a11y.getFocusableElements(this);

//         focusableElements.forEach((element) => {
//           element.addEventListener('focusin', () => {
//             const slide = element.closest('.swiper-slide');
//             this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
//           });
//         });
//       }
//       if (Shopify.designMode && typeof this.sliderInstance === 'object') {
//         document.addEventListener('shopify:block:select', (e) => {
//           if (e.detail.sectionId != this.sectionId) return;
//           let { target } = e;
//           const index = Number(target.dataset.index);

//           this.sliderInstance.slider.slideToLoop(index);
//         });
//       }
//     }

//     destroySlider() {
//       this.classList.remove(this.classes.swiper);
//       this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
//       this.sliderWrapper.classList.add(this.classes.grid);
//       if (typeof this.sliderInstance === 'object') {
//         this.sliderInstance.slider.destroy();
//         this.sliderInstance = false;
//       }
//     }
//   }
//   customElements.define('testimonials-component', Testimonials);
// }

if (!customElements.get('testimonials-component')) {
  class Testimonials extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.testimonials__items',
        pagination: '.swiper-pagination',
        nextEl: '.swiper-btn-next',
        prevEl: '.swiper-btn-prev',
      };
      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      this.enableSlider = this.dataset.enableSlider === 'true';
      this.items = parseInt(this.dataset.items);
      this.tabletItems = parseInt(this.dataset.tabletItems);
      this.tabletLargeItems = parseInt(this.dataset.tabletLargeItems);
      this.mobileItems = parseFloat(this.dataset.mobileItems) || 1;
      this.totalSlides = parseInt(this.dataset.totalSlides, 10) || 0;

      this.sliderInstance = false;

      if (!this.enableSlider) return;

      this.init();
      document.addEventListener('matchMobile', () => {
        this.init();
      });
      document.addEventListener('unmatchMobile', () => {
        this.init();
      });
    }

    init() {
      // Keep slider active on all viewport sizes (mobile included) so swipe/dots work on mobile
      this.initSlider();
    }

    initSlider() {
      const columnGap = FoxTheme.utils.getGridColumnGap(this.sliderWrapper);

      const paginationEl = this.section.querySelector(this.selectors.pagination);
      const sliderOptions = {
        slidesPerView: parseFloat(this.mobileItems) || 1,
        slidesPerGroup: 1,
        spaceBetween: columnGap.mobile,
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        pagination: paginationEl ? {
          el: paginationEl,
          clickable: true,
        } : false,
        breakpoints: {
          768: {
            slidesPerView: parseInt(this.tabletItems),
            spaceBetween: columnGap.tablet,
            slidesPerGroup: 1
          },
          1024: {
            slidesPerView: parseInt(this.tabletLargeItems),
            spaceBetween: columnGap.tabletLarge,
            slidesPerGroup: 1
          },
          1280: {
            slidesPerView: parseInt(this.items),
            spaceBetween: columnGap.desktop,
            slidesPerGroup: 1
          },
        },
        slidesPerGroup: 1,
        loop: true,
        threshold: 2,
      };

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();

        this.updateProgressBar();
        this.sliderInstance.slider.on('slideChangeTransitionEnd', () => this.updateProgressBar());
        this.sliderInstance.slider.on('slideChange', () => this.updateProgressBar());
        this.sliderInstance.slider.on('progress', () => this.updateProgressBar());

        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          });
        });
      }
      if (Shopify.designMode && typeof this.sliderInstance === 'object') {
        document.addEventListener('shopify:block:select', (e) => {
          if (e.detail.sectionId != this.sectionId) return;
          let { target } = e;
          const index = Number(target.dataset.index);

          this.sliderInstance.slider.slideToLoop(index);
        });
      }
    }

    updateProgressBar() {
      if (!this.section || typeof this.sliderInstance?.slider === 'undefined') return;
      const swiper = this.sliderInstance.slider;
      // Use scroll position (0–1) so bar is 100% only when last slide is fully in view
      const progress = typeof swiper.progress === 'number' ? swiper.progress : 0;
      const percent = Math.min(100, Math.round(progress * 100));
      const fills = this.section.querySelectorAll('.testimonials-slider-progress__fill');
      fills.forEach((el) => {
        el.style.width = `${percent}%`;
        el.setAttribute('aria-valuenow', percent);
      });
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);
      if (typeof this.sliderInstance === 'object') {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  }
  customElements.define('testimonials-component', Testimonials);
}
